module.exports = __webpack_public_path__ + "img/medium-v2-dark.4bd737dc.png";